module.exports = __webpack_public_path__ + "static/media/right-double.3c8d769d.svg";